import { render, staticRenderFns } from "./confirmAccountDelete.vue?vue&type=template&id=63fe84ca&"
import script from "./confirmAccountDelete.vue?vue&type=script&lang=js&"
export * from "./confirmAccountDelete.vue?vue&type=script&lang=js&"
import style0 from "./confirmAccountDelete.vue?vue&type=style&index=0&id=63fe84ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports